import { UserTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadCurrentUser = createAction('[User] Load Current User', props<{ username: string }>());

export const loadAnonymousUser = createAction('[User] Load Anonymous User');

export const loadCurrentUserSuccess = createAction(
  '[User] Load Current User Success',
  props<{ user: UserTypes.User }>()
);

export const loadCurrentUserFailure = createAction('[User] Load Current User Failure', props<{ error: any }>());

export const loadUserOrgs = createAction('[User] Load User Orgs', props<{ username: string }>());

export const loadUserOrgsSuccess = createAction(
  '[User] Load User Orgs Success',
  props<{ orgs: UserTypes.UserOrganization[] }>()
);

export const loadUserOrgsFailure = createAction('[User] Load User Orgs Failure', props<{ error: any }>());
